module.exports = __webpack_public_path__ + "static/scale-model-of-giant-eyeball-in-dallas-texas-7fda5e37a55a10b1a60720102cad0a94.png";